import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Alert, Form } from 'antd';
import { txt } from 'libs/i18n';
import { getLanguageFromTrsx } from 'api/project-api';
import SingleFileUpload from 'components/SingleFileUpload';
const handleTrsxValidation = (info) => {
    if (info === null) {
        return Promise.resolve();
    }
    const fileName = info.name;
    const fileType = fileName.slice(fileName.lastIndexOf('.') + 1);
    const isTrsx = fileType === 'trsx';
    return isTrsx === false
        ? Promise.reject(txt('fileNotTrsx'))
        : Promise.resolve();
};
const FileSettings = ({ allOrigins, originsList }) => {
    const form = Form.useFormInstance();
    const handleTrsxUpload = useCallback(async (file) => {
        // @ts-expect-error
        const trsx = await (file === null || file === void 0 ? void 0 : file.text());
        const lang = getLanguageFromTrsx(trsx);
        form.setFieldValue('language', lang);
    }, [form]);
    return allOrigins.length > 1 || originsList.urls.length > 0 ? (_jsx(Alert, { type: "info", showIcon: true, message: allOrigins.length > 1 ? txt('trsxForOneFile') : txt('trsxNotInLink') })) : (_jsx(Form.Item, { name: "trsxFile", valuePropName: "uploadFile", rules: [
            {
                validator: (_, validationInfo) => handleTrsxValidation(validationInfo),
            },
        ], children: _jsx(SingleFileUpload, { label: txt('trsxFile'), accept: ".trsx", onChange: handleTrsxUpload }) }));
};
export default FileSettings;
